import { Layout, TimeMechanism as TimeMechanismComponent } from "components"
export const TimeMechanism = () => {
 return (
  <Layout>
   <TimeMechanismComponent />
  </Layout>
 )
}
